import { FC } from "react"

import { useAuth } from "../../../../../../auth"

import { DLMLabellingUserActionsCell } from "../../../../../../setsco/doclabel/applications/application-view/labelling-list/DLMLabellingUserActionsCell"
import { DLMLabellingApplicantActionsCell } from "../../../../../../company/doclabel/application-view/labelling-list/DLMLabellingApplicantActionsCell"
import { DLMSiteApplication } from "../../../../_models"

type Props = {
  site: DLMSiteApplication 
}

const DLMLabellingActionsCell: FC<Props> = ({site}) => {
    
    const { currentUser } = useAuth();

    if (currentUser?.isSetsco)  {
        return <DLMLabellingUserActionsCell site={site} />
    }

    return <DLMLabellingApplicantActionsCell site={site} />
}

export {DLMLabellingActionsCell}
